import { Box, Button, Fade, Popper, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { Add, FileDownloadRounded } from "@mui/icons-material";
import SessionService from "../services/SessionService";
import { Permissions, } from "../models/Enum";
import SyncIcon from '@mui/icons-material/Sync';
import ConfirmationModal from "./ConfirmationModal";
import { ITEM_STATUS_OPTIONS } from "../pages/Products/EditItem/Constants";
import api from "../services/ApiService";
import { Item } from "../models/Items/Item";
import { toast } from "react-toastify";
import { ApiResponse } from "../models/ApiResponse";
import { useAppSelector } from "../store";
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';

interface ActionsProductListingProps {
    // handleSyncSAPComponent: () => void;
    handleExtractAttachment: () => void;
    getItems: () => void;
    selectedRows?: Item[];
    setSelectedRows?: (rows: Item[]) => void;
    allRecordsSelected?: boolean;
    setAllRecordsSelected?: (value: boolean) => void;
};

const ActionsProductListing = (props: ActionsProductListingProps) => {
    const { handleExtractAttachment, getItems, selectedRows, setSelectedRows, allRecordsSelected, setAllRecordsSelected } = props;
    const [popperAnchorEl, setPopperAnchorEl] = useState<null | HTMLElement>(null);
    const [showUpdateConfirmModal, setShowUpdateConfirmModal] = useState<boolean>(false);
    const [selectedStatus, setSelectedStatus] = useState<string | null>(null);
    const sessionService = SessionService.getInstance();
    const [showStatusOptions, setShowStatusOptions] = useState(false);
    //openPopper check if the popper is open or not;
    const openPopper = Boolean(popperAnchorEl);
    const productListFilterValuesSelected = useAppSelector((state) => state.filters.productListView.selectedFilterValues);

    const handlePopper = (event: React.MouseEvent<HTMLElement>) => {
        setPopperAnchorEl(popperAnchorEl ? null : event.currentTarget);
    };

    //needed for when use click out of popper
    useEffect(() => {
        if (openPopper) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [openPopper, showUpdateConfirmModal]);


    const handleCloseModal = () => {
        setShowUpdateConfirmModal(false);
    };

    const handleClickOutside = (event: MouseEvent) => {
        const target = event.target as Node;

        const popperContainer = document.querySelector('.MuiPopper-root');
        const modalDialog = document.querySelector('[role="dialog"]');

        const insidePopper = popperContainer?.contains(target);
        const insideModal = modalDialog?.contains(target);

        if (!insidePopper && !insideModal) {
            setPopperAnchorEl(null);
            setShowStatusOptions(false);
        }
    };

    const handleUpdateConfirm = async () => {
        try{
            const selectedProductIds = selectedRows?.map(row => row.id);
            setShowUpdateConfirmModal(false);
            const res = await api.put<ApiResponse<any>>(`/Item/update-item-status/${selectedStatus}`, 
                selectedProductIds?.length > 0 && !allRecordsSelected
                    ? {ids: selectedProductIds} 
                    : productListFilterValuesSelected
            )
            if(res?.isSuccess) {
                setPopperAnchorEl(null);
                setShowStatusOptions(false);
                setSelectedRows([]);
                setAllRecordsSelected(false);
                getItems();
                toast.success("Item Status updated successfully");
            } else {
                toast.error("Failed to update Item Status!");
                console.error("Error updating item status:", res?.message);
            }
        } catch (error) {
            console.error("Error updating item status:", error);
            toast.error("An error occurred while updating Item Status.");
        }
    };

    return (
        <>
            <Button
                onClick={handlePopper}
            >
                ACTIONS
            </Button>
            {<Popper
                open={openPopper}
                anchorEl={popperAnchorEl}
                placement={"bottom-start"}
                modifiers={[
                    {
                        name: 'flip',
                        enabled: false,
                    },
                    {
                        name: 'preventOverflow',
                        options: {
                            altBoundary: true,
                            tether: false,
                        },
                    },
                ]}
                transition
            >
                {({ TransitionProps }) => (
                    <Fade {...TransitionProps} timeout={250}>
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                bgcolor: 'background.paper',
                                border: 1,
                                borderColor: 'grey.300',
                                borderRadius: 1,
                                alignItems: "flex-start",
                                padding: 1
                            }}
                        >
                            {sessionService.hasPermission(Permissions.CreateProduct)
                                && <Button
                                    component="a"
                                    href="/create-product"
                                >
                                    <Add />
                                    Create Product
                                </Button>}
                            <Button
                                onClick={() => handleExtractAttachment()}
                            >
                                <FileDownloadRounded />
                                Extract Attachments
                            </Button>
                            {sessionService.hasPermission(Permissions.UpdateProduct) && <div className="item-status-update-container">
                                <Button
                                    onClick={() => setShowStatusOptions(prev => !prev)}
                                >
                                    <KeyboardDoubleArrowRightIcon />
                                    Update Item Status
                                </Button>
                                {showStatusOptions && (
                                    <Box
                                        className="item-status-update-options"
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            bgcolor: 'background.paper',
                                            border: 1,
                                            borderColor: 'grey.300',
                                            borderRadius: 1,
                                            padding: 1,
                                            mt: 1,
                                        }}
                                    >
                                        <Typography
                                            className="item-status-update-header"
                                            variant="h6"
                                            sx={{ mb: 1 }}
                                        >
                                            Update Status
                                        </Typography>
                                        {ITEM_STATUS_OPTIONS.map((status) => (
                                            <Button
                                                className="item-status-update-button"
                                                key={status?.value}
                                                onClick={() => {
                                                    setSelectedStatus(status?.value);
                                                    setShowUpdateConfirmModal(true);
                                                }}
                                            >
                                                {status?.name}
                                            </Button>
                                        ))}
                                    </Box>
                                )}
                            </div>}
                        </Box>
                    </Fade>
                )}
            </Popper>}
            <ConfirmationModal
                isOpen={showUpdateConfirmModal}
                onClose={handleCloseModal}
                title={"Confirm Update Item Status"}
                message={"Are you sure you want to update the Item Status?"}
                handleConfirmYes={handleUpdateConfirm}
                handleConfirmNo={handleCloseModal}
            />
        </>
    );
};

export default ActionsProductListing;